<template>
  <v-progress-linear :size="100" color="primary" indeterminate></v-progress-linear>
</template>

<script>
export default {
  name: "Loader"
};
</script>
